export default class PageLink {
	constructor ( indexClass ) {
		this.IndexClass= indexClass || jhc.Class.IndexClass.getInstance();
		this.routing= this.IndexClass.routing;
	}

	pageSelect (elem) {
		_jh.on('click', elem, (e)=> {
			this.pageSelectEvt(e);
		});
	}

	pageSelectEvt ( e ) {
		e.stopPropagation();
		e.preventDefault();
		const self= e.currentTarget;
		if( e.ctrlKey || e.shiftKey ) {
			const url= this.routing.setRouteName(self.dataset.routeName || self.pathname)
					, langPath= ( this.routing.lang !== 'ko' ) ? `/${this.routing.lang}` : ''
					,	goUrl= `${document.location.origin}${langPath}${url}`;
			window.open(goUrl, '_blank');
			return;
		}
		const routeName= self.dataset.routeName || self.pathname;
		this.routing.routing(routeName);
		this.IndexClass.menuClose();
	}
}